import React, { Component } from 'react';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { Col, Flex, Layout, Row, Typography, Image, Button } from 'antd';
import { ContentWrapp, FooterBlock, HeaderBlock, HeaderBlockMobile, Logo } from '../common';
import { IRootStoreProps, WithoutStore, withStore } from '../../stores';
import { observer } from 'mobx-react';
import { ChatBlock } from './components';
import routesConfig from '../../config/routes';
import { AppContext, AppContextValue } from '../../theme/AppContextProvider';
import { getUserBalance } from '../../utils';

const { Text } = Typography;

const headerLinks = [
  { link: routesConfig.gameKnb, name: 'КНБ' },
  { link: routesConfig.gameHot, name: 'ОРЛЯНКА' },
  { link: routesConfig.gameChat, name: 'ЧАТ' },
];

class _GamesLayout extends Component<IRootStoreProps> {
  static contextType = AppContext;
  render(): React.ReactNode {
    const breakPoint = this.context as AppContextValue;
    const { user, game, navigation } = this.props.store;
    const location = navigation.location?.pathname;

    if (!user.isAuth) {
      return <Navigate to={routesConfig.home} />;
    }

    console.log(navigation.location?.pathname);

    const balance = getUserBalance(game?.userBalance, user?.data);
    const name = user.data?.login;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <ContentWrapp style={{ flex: 1 }} isMobile={breakPoint.isMobile}>
          {breakPoint?.isMobile ? (
            <HeaderBlockMobile>
              <Flex
                justify={'space-between'}
                style={{ marginInline: 8, marginBottom: 5, borderRadius: 8, backgroundColor: '#F7F7F7', padding: 10 }}
              >
                <Flex>
                  <Image src={user.data?.imageUrl} width={20} />
                  <Text style={{ fontSize: 14, fontWeight: 600, marginLeft: 10 }}>{name}</Text>
                </Flex>

                <Flex align={'flex-end'}>
                  <Text style={{ fontSize: 12, fontWeight: 300, marginRight: 10, paddingBottom: 3 }}>{'БАЛАНС:'}</Text>
                  <Text style={{ fontSize: 16, fontWeight: 600 }}>{balance}</Text>
                </Flex>
              </Flex>
              <Col style={{ marginInline: 10, marginBottom: 10 }}>
                {headerLinks.map(el => (
                  <Link to={el.link} key={el.link}>
                    <Button
                      type={'text'}
                      style={{
                        borderColor: location === el.link ? '#E55A53' : '#D4D4D8',
                        borderWidth: 0,
                        borderBottomWidth: 2,
                        borderRadius: 0,
                      }}
                    >
                      {el.name}
                    </Button>
                  </Link>
                ))}
              </Col>
              <Col>
                <Outlet />
              </Col>
            </HeaderBlockMobile>
          ) : (
            <Row gutter={8} style={{ marginTop: 16 }}>
              <Col span={5}>
                <Logo isAuth={user.isAuth} />
                <ChatBlock />
              </Col>
              <Col span={19}>
                <HeaderBlock />
                <Layout style={{ paddingTop: 10 }}>
                  <Outlet />
                </Layout>
              </Col>
            </Row>
          )}
        </ContentWrapp>
        <FooterBlock />
      </div>
    );
  }
}

export const GamesLayout: WithoutStore = withStore(observer(_GamesLayout));
